import React, { useEffect, useState } from "react";
import { Button, Card, Col, Form, Input, Row, Select, SelectProps } from "antd";
import { UserOutlined, SaveOutlined, CloseOutlined } from "@ant-design/icons";
import HTTPService from "../../../utils/makerequest";
import toast from "react-hot-toast";
import { IAuthentication, UserRole } from "../../../interfaces/authentication";
import { StateLoader } from "../../../redux/StateLoader";
import { ICompanyData } from "../../../interfaces/ICompanyData";
import { useTranslation } from 'react-i18next';
import { ICampusData } from "../../../interfaces/ICampusData";
import { ILocationData } from "../../../interfaces/ILocationData";
import Dropdown from "../../../AltisComponent/Dropdown";

const AddLocation: React.FC<ILocationData> = ({ savedObj, cancelModal, companyId, campusId, locationName, campusTBL }) => {
    const { t } = useTranslation();
    const [campusData, setCampusData] = useState<ICampusData[]>([]);
    const [companyData, setCompanyData] = useState<ICompanyData[]>([]);
    const [selectedCompany, setSelectedCompany] = useState<number>();
    //const [selectedCampus, setSelectedCampus] = useState<number>();
    const loader = new StateLoader();
    const userInfo: IAuthentication = loader.loadAuthState();
    const isCompanyIdAvailable = !!companyId;
    const isCampusIdAvailable = !!campusId;


    useEffect(() => {
        fetchCompanyData();
    }, []);

    useEffect(() => {
        if (selectedCompany || userInfo.companyId) {
            fetchCampusesByCompany(selectedCompany || userInfo.companyId);
        } else {
            setCampusData([]);
        }
    }, [selectedCompany]);

    useEffect(() => {
        if (companyId !== undefined) {
            setSelectedCompany(companyId);
        } else if (campusId !== undefined) {
            //setSelectedCampus(campusId)
        }
    }, [companyId, campusId]);


    const fetchCompanyData = async () => {
        try {
            const result = await HTTPService.GETCompanyNames();
            setCompanyData(result);
        } catch (error) {
            console.error("Şirket verilerini alırken bir hata oluştu:", error);
        }
    };

    const filterOption: SelectProps<any>['filterOption'] = (input, option) => {
        return (option?.children as unknown as string).toLowerCase().includes(input.toLowerCase());
    };

    const fetchCampusesByCompany = async (companyId: number) => {
        try {
            const result = await HTTPService.GETCampusByCompany(companyId);
            setCampusData(result);
        } catch (error) {
            console.error("Kampüs verilerini alırken bir hata oluştu:", error);
            setCampusData([]);
        }
    };

    const handleCompanyChange = (value: number) => {
        setSelectedCompany(value);
    };


    const handleCancel = () => {
        const currentUrl = window.location.href;
        const addInventoryUrl = 'admin/add-inventory';
        const updateInventoryUrl = 'admin/update-inventory';
        const inventoryManage = 'admin/inventory-management';

        if (currentUrl.includes(addInventoryUrl)) {
            cancelModal();
        } else if (currentUrl.includes(updateInventoryUrl)) {
            cancelModal();
        }
        else if (currentUrl.includes(inventoryManage)) {
            cancelModal();
        }
        else {
            window.location.replace('/admin/location-management');
        }
    };

    const LocationRegister = (values) => {
        let companyIdToUse;
        if (userInfo?.role === UserRole.AltisAdmin) {
            companyIdToUse = setSelectedCompany(values.companyId);
        } else {
            companyIdToUse = userInfo?.companyId;
        }

        const newGroup = {
            locationName: values.locationName,
            companyId: companyIdToUse || companyId,
            campusId: values.campusId || campusId,
        };

        HTTPService.POST(`/Location/registerLocation`, newGroup)
            .then((response) => {
                if (response.status === 200) {
                    const currentUrl = window.location.href;
                    const redirectUrl = 'admin/add-location';
                    if (currentUrl.includes(redirectUrl)) {
                        window.location.replace('admin/location-management');
                    }
                    else if (response.status === 450) {
                        toast.error(t(response.data))
                    }
                    else {
                        savedObj(response.data)
                        cancelModal();
                    }
                } else {
                    toast.error(t(response.data));
                }
            })
            .catch((error) => {
                toast.error("Location registration failed.");
            });
    };

    return (
        <Card style={{ padding: "50px" }}>
            <h3>{t('register_location')}</h3>
            <Form onFinish={LocationRegister} layout="vertical"
                fields={[
                    { name: ["selectedCompany"], value: companyId },
                    { name: ["selectedCampus"], value: campusId },
                ]}
            >
                {!isCompanyIdAvailable && userInfo?.role === UserRole.AltisAdmin ? (
                    <Form.Item
                        //name='selectedCompany'
                        label={t('Select company')}
                        rules={[{ required: true, message: t('please_select_a_company') }]}
                    >
                        <Select
                            showSearch
                            placeholder={t('company_name')}
                            style={{ width: '100%', marginBottom: '16px' }}
                            onChange={handleCompanyChange}
                            filterOption={filterOption}
                        >
                            {companyData.map((company) => (
                                <Select.Option key={company.companyId} value={company.companyId}>
                                    {company.companyName}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>
                ) : null}

                {!isCampusIdAvailable && (

                    <Form.Item
                        label={t('campus')}
                        name="campusId"
                        rules={[{ required: true, message: t('campusName') }]}
                    >
                        <Dropdown
                            name="campusId"
                            label={t('campus')}
                            rules={[{ required: true, message: t('select_campus') }]}
                            placeholder={t('campus')}
                            dataSource={campusData}
                            labelKey="campusName"
                            valueKey="campusId"
                            style={{ width: '100%' }}
                        />
                    </Form.Item>

                )}



                <Form.Item
                    name="locationName"
                    label={t('location')}
                    rules={[{ required: true, message: t('please_input_your_location'), whitespace: true }]}
                >
                    <Input
                        prefix={<UserOutlined />}
                        style={{ borderRadius: '4px', width: '100%' }}
                        placeholder={t('location')}
                        maxLength={50}
                    />
                </Form.Item>

                <Form.Item>
                    <Row gutter={[4, 4]} justify="end" align="middle">
                        <Col xs={12} sm={4}>
                            <Button
                                block
                                onClick={handleCancel}
                                type="primary"
                                style={{
                                    height: 64,
                                    backgroundColor: 'transparent',
                                    color: '#1890ff',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    padding: '0 10px',
                                    border: 'none',
                                    transition: 'all 0.3s ease',
                                    cursor: 'pointer'
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.transform = 'scale(1.05)';
                                    e.currentTarget.style.boxShadow = '0 8px 16px rgba(0,0,0,0.2)';
                                    e.currentTarget.style.color = '#40a9ff';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = 'scale(1)';
                                    e.currentTarget.style.boxShadow = 'none';
                                    e.currentTarget.style.color = '#1890ff';
                                }}
                            >
                                <CloseOutlined style={{ fontSize: 20 }} />
                                <span style={{ fontSize: '12px', marginTop: '8px', textAlign: 'center' }}>
                                    {t('cancel')}
                                </span>
                            </Button>
                        </Col>
                        <Col xs={12} sm={4}>
                            <Button
                                block
                                htmlType="submit"
                                type="primary"
                                style={{
                                    height: 64,
                                    backgroundColor: 'transparent',
                                    color: '#1890ff',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    padding: '0 10px',
                                    border: 'none',
                                    transition: 'all 0.3s ease',
                                    cursor: 'pointer'
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.transform = 'scale(1.05)';
                                    e.currentTarget.style.boxShadow = '0 8px 16px rgba(0,0,0,0.2)';
                                    e.currentTarget.style.color = '#40a9ff';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = 'scale(1)';
                                    e.currentTarget.style.boxShadow = 'none';
                                    e.currentTarget.style.color = '#1890ff';
                                }}
                            >
                                <SaveOutlined style={{ fontSize: 20 }} />
                                <span style={{ fontSize: '12px', marginTop: '8px', textAlign: 'center' }}>
                                    {t('save')}
                                </span>
                            </Button>
                        </Col>
                    </Row>
                </Form.Item>
            </Form>
        </Card>
    );
};

export default AddLocation;
